export enum ReadOnlyWarningType {
    CustomerApplicationCancelled = 'customerApplicationCancelled',
    CustomerApplicationHandedOver = 'customerApplicationHandedOver',
    CustomerFrnRequestCancelled = 'customerFrnRequestCancelled',
    CustomerFrnRequestHandedOver = 'customerFrnRequestHandedOver',
    StaffApplicationCancelled = 'staffApplicationCancelled',
    StaffFrnRequestCancelled = 'staffFrnRequestCancelled',
    StaffApplicationSubmitted = 'staffApplicationSubmitted',
}

export type ReadOnlyWarningSubject = 'application' | 'frnRequest';

export type ReadOnlyWarningContext =
    | {
          subject: 'application';
          role: 'customer';
          reason: 'cancelled' | 'handedOver';
      }
    | {
          subject: 'application';
          role: 'staff';
          reason: 'cancelled' | 'submitted';
      }
    | {
          subject: 'frnRequest';
          role: 'customer';
          reason: 'cancelled' | 'handedOver';
      }
    | {
          subject: 'frnRequest';
          role: 'staff';
          reason: 'cancelled';
      };

export const getReadOnlyWarningType = (
    context: ReadOnlyWarningContext,
): ReadOnlyWarningType => {
    if (context.subject === 'application') {
        if (context.role === 'customer') {
            return context.reason === 'cancelled'
                ? ReadOnlyWarningType.CustomerApplicationCancelled
                : ReadOnlyWarningType.CustomerApplicationHandedOver;
        }

        return context.reason === 'cancelled'
            ? ReadOnlyWarningType.StaffApplicationCancelled
            : ReadOnlyWarningType.StaffApplicationSubmitted;
    }

    if (context.role === 'customer') {
        return context.reason === 'cancelled'
            ? ReadOnlyWarningType.CustomerFrnRequestCancelled
            : ReadOnlyWarningType.CustomerFrnRequestHandedOver;
    }

    return ReadOnlyWarningType.StaffFrnRequestCancelled;
};
